import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    DeleteContractFromWorkShift,
    DeleteUserFromWorkShift,
} from '../../../../../reduxToolkit/CompanyWorkShift/CompanyWorkShiftApi';
import { DeleteItemsApi } from '../../../../../reduxToolkit/Commons/CommonsApi';
import {TABLES} from "../../../../../Apis/Tables";

const AccessRightsApp = ({
    userData,
    workShiftsList,
    setWorkShiftsList,
    customizedList,
    setCustomizedList,
    contractorItemId,
    contractId,
    isEditable,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [addWorkShiftsDialogShow, setAddWorkShiftsDialogShow] = useState(false);
    const [addCustomizedDialogShow, setAddCustomizedDialogShow] = useState(false);
    const [selectWorkShiftForDelete, setSelectWorkShiftForDelete] = useState([]);
    const [isAllCheckedWorkShift, setIsAllCheckedWorkShift] = useState(false);
    const [deleteWorkShiftShow, setDeleteWorkShiftShow] = useState(false);
    const [deleteCustomizedShow, setDeleteCustomizedShow] = useState(false);
    const [singleWorkShiftForDelete, setSingleWorkShiftForDelete] = useState([]);
    const [singleCustomizedForDelete, setSingleCustomizedForDelete] = useState([]);
    const [deleteSingleWorkShiftShow, setDeleteSingleWorkShiftShow] = useState(false);
    const [deleteSingleCustomizedShow, setDeleteSingleCustomizedShow] = useState(false);
    const [selectCustomizedForDelete, setSelectCustomizedForDelete] = useState([]);
    const [isAllCheckedCustomized, setIsAllCheckedCustomized] = useState(false);
    // Controls whether editing options are visible based on editability
    const [showOptions, setShowOptions] = useState(true);
    useEffect(() => {
        if (isAllCheckedWorkShift) {
            setIsAllCheckedWorkShift(false);
        }
    }, [workShiftsList]);
    useEffect(() => {
        setShowOptions(isEditable);
    }, [isEditable]);

    const handleRemoveAllWorkShifts = (e) => {
        setIsAllCheckedWorkShift(e.target.checked);
        if (e.target.checked) {
            const selectAllIndex = workShiftsList.map((item, index) => {
                return index;
            });
            setSelectWorkShiftForDelete(selectAllIndex);
        } else {
            setSelectWorkShiftForDelete([]);
        }
    };

    // this function control select all index or unSelect all
    const handleRemoveAllCustomized = (e) => {
        setIsAllCheckedCustomized(e.target.checked);
        if (e.target.checked) {
            const selectAllIndex = customizedList.map((item, index) => {
                return index;
            });
            setSelectCustomizedForDelete(selectAllIndex);
        } else {
            setSelectCustomizedForDelete([]);
        }
    };

    // this function handle only specific id base on selection
    const handleCheckboxChangeWorkShift = (e) => {
        if (e.target.checked) {
            setSelectWorkShiftForDelete([...selectWorkShiftForDelete, parseInt(e.target.id)]);
        } else {
            setSelectWorkShiftForDelete(
                selectWorkShiftForDelete.filter((removeId) => removeId !== parseInt(e.target.id)),
            );
        }
    };

    // this function handle only specific index base on selection
    const handleCheckboxChangeCustomized = (e) => {
        if (e.target.checked) {
            setSelectCustomizedForDelete([...selectCustomizedForDelete, parseInt(e.target.id)]);
        } else {
            setSelectCustomizedForDelete(
                selectCustomizedForDelete.filter((removeId) => removeId !== parseInt(e.target.id)),
            );
        }
    };

    const deleteSelectedManageUser = (deleteItem) => {
        const selectedIndexNew = deleteItem.filter((index) => {
            return index >= 0 && index < workShiftsList.length && workShiftsList[index].new;
        });
        const updatedList = workShiftsList.filter((item, index) => {
            return !selectedIndexNew.includes(index);
        });
        setWorkShiftsList(updatedList);

        const body = deleteItem
            .map((index) => workShiftsList[index])
            .filter((item) => !item.new)
            .map((item) => item.id);
        if (body.length > 0) {
            if (contractorItemId === undefined) {
                const data = {
                    userIds: [userData.id],
                    workShiftIds: body,
                };
                dispatch(DeleteUserFromWorkShift(data)).then(
                    ({
                        payload: {
                            data: { success },
                        },
                    }) => {
                        if (success === true) {
                            const updatedList = workShiftsList.filter((item, index) => {
                                return !deleteItem.includes(index);
                            });
                            setWorkShiftsList(updatedList);
                        }
                    },
                );
            } else {
                const data = {
                    contractorIds: [contractorItemId],
                    workShiftIds: body,
                };
                dispatch(DeleteContractFromWorkShift(data)).then(
                    ({
                        payload: {
                            data: { success },
                        },
                    }) => {
                        if (success === true) {
                            const updatedList = workShiftsList.filter((item, index) => {
                                return !deleteItem.includes(index);
                            });
                            setWorkShiftsList(updatedList);
                        }
                    },
                );
            }
        }
        if (singleCustomizedForDelete.length > 0) {
            setSingleWorkShiftForDelete([]);
        } else {
            setSelectWorkShiftForDelete([]);
            setIsAllCheckedWorkShift(false);
        }
    };

    const deleteSelectedCustomized = (deleteItem) => {
        const tableName = !contractId ? TABLES.USER_WORK_SCHEDULE : TABLES.CONTRACTOR_WORK_SCHEDULE;
        const selectedIndexNew = deleteItem.filter((index) => {
            return index >= 0 && index < customizedList.length && customizedList[index].new;
        });
        const updatedList = customizedList.filter((item, index) => {
            return !selectedIndexNew.includes(index);
        });
        setCustomizedList(updatedList);
        const body = deleteItem
            .map((index) => customizedList[index])
            .filter((item) => !item.new)
            .map((item) => item.id);
        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName, body })).then(
                ({
                    payload: {
                        data: { success },
                    },
                }) => {
                    {
                        if (success === true) {
                            const updatedList = customizedList.filter((item, index) => {
                                return !deleteItem.includes(index);
                            });
                            setCustomizedList(updatedList);
                        }
                    }
                },
            );
        }
        if (singleCustomizedForDelete.length > 0) {
            setSingleCustomizedForDelete([]);
        } else {
            setSelectCustomizedForDelete([]);
            setIsAllCheckedCustomized(false);
        }
    };

    return {
        t,
        permission,
        DEV,
        selectWorkShiftForDelete,
        setSelectWorkShiftForDelete,
        setIsAllCheckedWorkShift,
        selectCustomizedForDelete,
        setSelectCustomizedForDelete,
        setIsAllCheckedCustomized,
        addWorkShiftsDialogShow,
        setAddWorkShiftsDialogShow,
        addCustomizedDialogShow,
        setAddCustomizedDialogShow,
        deleteWorkShiftShow,
        setDeleteWorkShiftShow,
        deleteSingleWorkShiftShow,
        setDeleteSingleWorkShiftShow,
        singleWorkShiftForDelete,
        setSingleWorkShiftForDelete,
        deleteCustomizedShow,
        setDeleteCustomizedShow,
        deleteSingleCustomizedShow,
        setDeleteSingleCustomizedShow,
        singleCustomizedForDelete,
        setSingleCustomizedForDelete,
        showOptions,
        setShowOptions,
        deleteSelectedCustomized: (e) => deleteSelectedCustomized(e),
        deleteSelectedManageUser: (e) => deleteSelectedManageUser(e),
        handleCheckboxChangeCustomized: (e) => handleCheckboxChangeCustomized(e),
        handleCheckboxChangeWorkShift: (e) => handleCheckboxChangeWorkShift(e),
        handleRemoveAllCustomized: (e) => handleRemoveAllCustomized(e),
        handleRemoveAllWorkShifts: (e) => handleRemoveAllWorkShifts(e),
    };
};

export default AccessRightsApp;
